export enum OrgIdTypeEnum {
  BET9JA = 'bet9ja',
  YAJUEGO = 'yajuego',
  MOZZARTBET = 'mozzartbet',
  MOZZARTBET_SERBIA = 'mozzartbet-serbia',
  GLI = 'gli_certification',
  TEAPUESTO = 'teapuesto',
  TEAPUESTO_PERU = 'teapuesto-peru',
  SOCCERBET_SERBIA = 'soccerbet-serbia',
  MAYBETS_KENYA = 'maybets-kenya',
  MAMABET = 'mamabet',
  MOZZARTBET_CROATIA = 'mozzartbet-croatia',
  SPIN_AND_WIN = 'spin-and-win',
  BET9JA_SHOP_APP = 'bet9ja-shop-app',
  BET9JA_AGENT = 'bet9ja-agent',
  GAMING_HUB = 'gaming-hub',
  ARISTOCRAT_ZIMBABWE = 'aristocrat-zimbabwe',
  ARISTOCRAT_GABON = 'aristocrat-gabon',
  ARISTOCRAT_PREMIERBET_CAMEROON = 'aristocrat-premierbet-cameroon',
  ARISTOCRAT_PREMIERBET_MALAWI = 'aristocrat-premierbet-malawi',
  ARISTOCRAT_PREMIERBET_UGANDA = 'aristocrat-premierbet-uganda',
  ARISTOCRAT_PREMIERBET_CONGO = 'aristocrat-premierbet-congo',
  ARISTOCRAT_PREMIERBET_SIERRA_LEONE = 'aristocrat-premierbet-sierra-leone',
  ARISTOCRAT_PREMIERBET_SENEGAL = 'aristocrat-premierbet-senegal',
  PREMIERBET = 'premierbet',
  ARISTOCRAT_PREMIERBET_CHAD = 'aristocrat-premierbet-chad',
  ARISTOCRAT_PREMIERBET_MOZAMBIQUE = 'aristocrat-premierbet-mozambique',
  ARISTOCRAT_PREMIERBET_MALI = 'aristocrat-premierbet-mali',
  ARISTOCRAT_PREMIERBET_ANGOLA = 'aristocrat-premierbet-angola',
  ARISTOCRAT_PREMIERBET_TANZANIA = 'aristocrat-premierbet-tanzania',
  ARISTOCRAT_PREMIERBET_GUINEA = 'aristocrat-premierbet-guinea',
  ARISTOCRAT_PREMIERBET_LIBERIA = 'aristocrat-premierbet-liberia',
  ARISTOCRAT_PREMIERBET_ETHIOPIA = 'aristocrat-premierbet-ethiopia',
  ARISTOCRAT_PREMIERBET_IVORY_COAST = 'aristocrat-premierbet-ivory-coast',
  ARISTOCRAT_PREMIERBET_NAMIBIA = 'aristocrat-premierbet-namibia',
}
